
import React, { useContext } from 'react';
import { Image } from 'primereact/image';
import axios from "../context/axios";
import 'primeicons/primeicons.css';
import { Checkbox } from "primereact/checkbox";
import { useState } from 'react';
import STcontext from '../context/STcontext';

export default function ImagePreview({ image, id, handleCheckboxChange }) {
   const { selectedImages } = useContext(STcontext);
   return (
      <div className="flex justify-content-center" style={{ width: "auto", position: "relative" }}>
         <div className="card flex justify-content-center" style={{ position: "absolute", top: "1%", right: "6%", zIndex: "999" }}>
            <Checkbox checked={selectedImages?.includes(id)} name="checked" value={id} inputId={id} onChange={handleCheckboxChange}></Checkbox>
         </div>

         <Image src={`${axios.defaults.baseURL}images/${image}`} alt="Image" width="250" preview />
      </div>
   )
}
